import React, { useCallback, useState } from "react";
import { observer } from "mobx-react-lite";
import { useHistory } from "react-router-dom";

import PageLayout from "../../_layout/PageLayout";
import { api } from "../../../services/api/ApiService";
import { SettingsMenuItemsModel } from "../SettingsMenuItems";
import AddNewButton from "../../../components/buttons/add-new-button/AddNewButton";
import DragAndDropTable from "../../../components/drag-and-drop-list/DragAndDropTable";
import { ViewOrganizationProjectProperties } from "../../../services/authorization/Permissions";
import { ProjectPropertiesStorageModel } from "../../../services/organization/ProjectPropertyStorage";
import {
  ActionsSection,
  ButtonsSection,
} from "../../../components/data-components/sections/DataSections";
import { CustomProjectPropertyOptionResponse } from "../../../api-models/response/CustomProjectPropertyValueResponse";

export default observer(() => {
  const history = useHistory();

  const [settingsMenuItems] = useState(() =>
    SettingsMenuItemsModel.create({ })
  );

  const [projectPropertyStorage] = useState(() =>
    ProjectPropertiesStorageModel.create({}, { api })
  );

  const menuItems = {
    staticItems: settingsMenuItems.getStaticItems(),
  };

  const handleAddClick = () => {
    history.push("/settings/project-properties/create");
  };

  const handlePositionUpdate = useCallback(() => {
    projectPropertyStorage.updatePosition();
  }, [projectPropertyStorage]);

  const handlePropertyClick = useCallback(
    (property: CustomProjectPropertyOptionResponse) => {
      history.push("/settings/project-properties/" + property.id);
    },
    [history]
  );

  return (
    <PageLayout
      accessWithOneOfThePermissions={[ViewOrganizationProjectProperties]}
      id="view-project-properties"
      titleKey="general.custom-project-details"
      menuItems={menuItems}
      isLoading={projectPropertyStorage.isLoading}
    >
      <ActionsSection>
        <ButtonsSection>
          <AddNewButton onClick={handleAddClick} />
        </ButtonsSection>
      </ActionsSection>
      <DragAndDropTable
        storage={projectPropertyStorage}
        handlePositionUpdate={handlePositionUpdate}
        itemTypeKey="general.custom-project-details"
        rowClickCallback={handlePropertyClick}
      />
    </PageLayout>
  );
});
